import CommonEdit from "@/components/common/NewEdit";
import OrderFormTaxiCommon from "@/components/common/OrderFormTaxi";
import { Location } from "@/interface/dataInterface";
import { Orders } from "@/interface/entityInterface";
import { OrderForm } from "@/interface/formInterface";
import { mergeDateAndTime, seperateDateAndTime } from "@/utils/formChange";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedOrder: Orders | null;
}

const OrderDetailEdit: FC<Props> = ({ isOpen, setOpen, selectedOrder }) => {
  const [formProp, setFormProp] = useState<OrderForm>({
    fullName: "",
    email: "",
    date: "",
    fare: "",
    status: "",
    client_phone: "",
    notes: "",
    currency: "",
    time: "",
  });
  const [pickup, setPickup] = useState<Location>({
    text: "",
    lat: 0,
    lng: 0,
  });
  const [dropoff, setDropoff] = useState<Location>({
    text: "",
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
    if (!selectedOrder?.id) return;
    const {
      client_name,
      client_phone,
      pickup_time,
      notes,
      currency,
      fare,
      email,
      status,
      pickup,
      pickup_latitude,
      pickup_longitude,
      dropoff,
      dropoff_latitude,
      dropoff_longitude,
    } = selectedOrder;
    const seperateDate = seperateDateAndTime(pickup_time);
    setFormProp({
      date: seperateDate.datePart,
      time: seperateDate.timePart,
      fullName: client_name || "",
      email: email || "",
      fare: fare || "",
      currency,
      notes: notes || "",
      client_phone: client_phone || "",
      status,
    });
    setPickup({
      text: pickup,
      lat: pickup_latitude,
      lng: pickup_longitude,
    });
    setDropoff({
      text: dropoff,
      lat: dropoff_latitude,
      lng: dropoff_longitude,
    });
  }, [selectedOrder?.id]);

  if (!selectedOrder) return;

  return (
    <CommonEdit
      isOpen={isOpen}
      setIsOpen={setOpen}
      title={`Edit order #${selectedOrder.id}`}
      id={selectedOrder?.id}
      resource="taxi-orders"
      data={{
        ...selectedOrder,
        fare: formProp.fare || 0,
        currency: formProp.currency,
        email: formProp.email,
        pickup_time: mergeDateAndTime(formProp.date, formProp.time),
        client_name: formProp.fullName,
        client_phone: formProp.client_phone,
        notes: formProp.notes,
        status: formProp.status,
        pickup: pickup.text,
        pickup_latitude: pickup.lat,
        pickup_longitude: pickup.lng,
        dropoff: dropoff.text,
        dropoff_latitude: dropoff.lat,
        dropoff_longitude: dropoff.lng,
      }}
    >
      <OrderFormTaxiCommon
        formProp={formProp}
        setFormProp={setFormProp}
        location={pickup}
        setLocation={setPickup}
        dropoff={dropoff}
        setDropoff={setDropoff}
      />
    </CommonEdit>
  );
};

export default OrderDetailEdit;
